import { ReactNode, CSSProperties } from 'react';
import classes from './style.module.scss';
export enum Ecolor {
  deep = 'deep',
  light = 'light',
}
interface Iprops {
  children: ReactNode;
  color?: Ecolor | '';
  style?: CSSProperties;
  cssClass?: string;
  required?: boolean;
}

const Text = ({
  children,
  color = '',
  style,
  cssClass = '',
  required,
}: Iprops) => {
  return (
    <span
      className={
        classes.text +
        ' ' +
        (color === Ecolor.deep ? 'color-text-deep' : 'color-text-light') +
        ' ' +
        cssClass
      }
      style={{
        ...style,
      }}
      data-required={required}
    >
      {children}
    </span>
  );
};
export default Text;
